export const deliveryManifest = {
    id: 'delivery',
    name: 'Delivery',
    description: 'Point-to-point and multi-stop delivery service',
    version: '1.1.0',
    icon: 'Package',
    dependencies: ['maps', 'payments'],
    compatibleVehicles: ['car', 'van_s', 'van_m', 'van_l', 'van_xl', 'luton'],
    allowedRoles: ['customer', 'driver', 'business', 'admin'],
    supportsB2B: true,
    b2bFeatures: {
        multiStop: true,
        maxStops: 20,
        routeOptimization: true,
        proofOfDelivery: true,
        customerNotifications: true,
        barcodeScanning: false,
    },
    pricing: {
        configurable: true,
        b2bConfigurable: true,
        fields: [
            { key: "vatRate", type: "percentage", label: "VAT Rate", hint: "UK VAT percentage applied to all charges", format: "percent", defaultValue: 0, min: 0, max: 100 },
            { key: 'serviceFee', type: 'money', label: 'Platform Booking Fee', hint: 'Flat platform fee charged per booking (in pence)', format: 'pence', defaultValue: 0, required: true },
            { key: 'basePrice', type: 'money', label: 'Base Price (incl. miles)', hint: 'Base price that includes the included miles (in pence)', format: 'pence', defaultValue: 0, required: true },
            { key: 'includedMiles', type: 'number', label: 'Miles Included in Base', hint: 'Number of miles covered by the base price', format: 'number', defaultValue: 0, min: 0, required: true },
            { key: 'pricePerExtraMile', type: 'money', label: 'Price per Extra Mile', hint: 'Charge per mile beyond included miles (in pence)', format: 'pence', defaultValue: 0, required: true },
            { key: 'pricePerStop', type: 'money', label: 'Price per Additional Stop', hint: 'Charge for each stop beyond the first (in pence)', format: 'pence', defaultValue: 0, required: true },
            { key: 'pricePerKg', type: 'money', label: 'Price per Kg', hint: 'Weight-based surcharge per kilogram (in pence)', format: 'pence', defaultValue: 0 },
            { key: 'pricePerM3', type: 'money', label: 'Price per m³ (volume)', hint: 'Volume-based surcharge per cubic metre (in pence)', format: 'pence', defaultValue: 0 },
            { key: 'minDistance', type: 'number', label: 'Minimum Distance (miles)', hint: 'Shortest trip distance to qualify for this service', format: 'number', defaultValue: 0 },
            { key: 'expressMultiplier', type: 'percentage', label: 'Express Multiplier', hint: 'Price multiplier for express/priority delivery', format: 'percent', defaultValue: 0, min: 1, max: 5 },
            // Bundle matching
            { key: 'bundleEnabled', type: 'boolean', label: 'Enable Bundle Matching', hint: 'Allow grouping multiple deliveries on one route', format: 'boolean', defaultValue: false },
            { key: 'bundleMaxJobs', type: 'number', label: 'Max Jobs per Route', hint: 'Maximum deliveries bundled on a single route', format: 'number', defaultValue: 0, min: 1, max: 10 },
            { key: 'bundleMaxDeviationMiles', type: 'number', label: 'Max Route Deviation (miles)', hint: 'Maximum detour allowed for bundle matching', format: 'number', defaultValue: 0, min: 0 },
            { key: 'bundleDiscounts', type: 'text', label: 'Bundle Discounts (% comma-separated)', hint: 'Discount percentages for each additional job, e.g. "5,10,15,20" (1 child=5%, 2=10%, 3=15%, 4=20%)', format: 'text', defaultValue: '5,10,15,20' },
        ],
    },
    features: {
        requiresInventory: false,
        requiresPropertyType: false,
        allowsMultiDrop: true,
        requiresFloorInfo: false,
        hasAssemblyOption: false,
    },
};
//# sourceMappingURL=manifest.js.map